import type { ButtonHTMLAttributes } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { useMobileSidebar } from '../contexts/MobileSidebarContext';
import { useGetCurrentUserQuery } from '../gql/generated';
import { Avatar } from './Avatar';

type AccountButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export function AccountButton({ ...rest }: AccountButtonProps) {
  const { close } = useMobileSidebar();

  const navigate = useNavigate();
  const { user: authUser, isAuthenticated } = useAuth();

  // Fetch current user from GraphQL (only if authenticated)
  const { data: userData } = useGetCurrentUserQuery({
    skip: !isAuthenticated,
    errorPolicy: 'all', // Don't crash on auth errors
  });

  // Determine loading state

  // Determine user data source (prioritize GraphQL data, fallback to MSAL)
  const user = userData?.currentUser || authUser;
  const userName = user?.name || user?.email || 'User';

  return (
    <div>
      <button
        onClick={() => {
          navigate('/account');
          close();
        }}
        {...rest}
        className={`text-secondary size-p1 hover:bg-surface-focus-support flex
          cursor-pointer flex-row items-center space-x-4 rounded-md p-2
          ${rest.className || ''}`}
      >
        <Avatar src={''} alt={`${userName}'s avatar`} />
        <span className=''>{userName}</span>
      </button>
    </div>
  );
}
